var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDoorPqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4254 0H0V16H19V6.69356L11.4254 0ZM18.3692 15.3719H0.630785V0.628063H11.1856L18.3692 6.97636V15.3719Z",
    fill: "#56C3EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5698 6.42115H2.17212V1.89111H10.4001L15.5698 6.42115Z",
    fill: "#56C3EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 3,
    height: 1,
    fill: "#56C3EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDoorPqe);
export default __webpack_public_path__ + "static/media/car_door_pqe.51f8835eb364557947391e925eeb4865.svg";
export { ForwardRef as ReactComponent };